const resolveLocalizedField = ({ localizedValues, language, fallback }) => localizedValues?.[language] || fallback;
export default resolveLocalizedField;
